export default __webpack_public_path__ + "static/media/christmas_card_feature.2a389702.mp4";